import { Dispatch, GetState } from "common/types";

import { signUp as signUpFirebase } from "services/firebase/auth";

import {
  getRegion,
  signInError,
  signInStart,
  signUpSuccess
} from "seneca-common/features/user/state";
import {
  analyticsLogSignUp,
  analyticsReferredUserSignUp
} from "seneca-common/utils/senecaAnalytics";
import logError, { logMessage } from "seneca-common/utils/sentry/logError";

import { setRegionPreference } from "../../actions/preferences";
import { setUserAsSignedUpBefore } from "../../utils/signedUpBefore";
import { saveUserInfo } from "../userInfo";
import { reconcileData } from "./utils";

export function signUp(
  userDetails: Record<string, any>,
  password: string,
  referralCode?: string
) {
  return async function (dispatch: Dispatch, getState: GetState) {
    try {
      dispatch(signInStart());

      const region = getRegion(getState()); // region needed so we can save it after sign up

      await signUpFirebase(userDetails.email, password);

      try {
        await dispatch(saveUserInfo(userDetails));
      } catch (err: any) {
        // log both message and error so we can see top level grouping
        // and full error stack
        logMessage("created user with missing user info record", {
          extraInfo: {
            errorMessage: err.message
          }
        });
        logError(err);
      }

      await dispatch(reconcileData());

      setUserAsSignedUpBefore();

      dispatch(signUpSuccess());

      region && dispatch(setRegionPreference(region));

      analyticsLogSignUp(getState());
      referralCode && analyticsReferredUserSignUp(referralCode); // probably still relied upon
    } catch (error: any) {
      dispatch(signInError());
      throw error;
    }
  };
}
